module.exports = "https://r.nearpod.com/assets/media/image/time-to-climb-6ba95233c63727e346b4f60f4d503a24.svg";